module.exports = __webpack_public_path__ + "static/media/bazing-black-logo.df06c2c8.png";